import React from 'react';
import Modal from "../modal";
import { Bounce } from 'react-activity';
import 'react-activity/dist/react-activity.css';

const LoadingSpinner = props => {
  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems:"center", position:"absolute"}}>
      <Bounce size="2rem" color="#C0A9BD" />
    </div>
  );
};

export default LoadingSpinner;
